module.exports = __webpack_public_path__ + "f075c50f89795e4cdb4d45b51f1a6800.woff2";